const formLabelFormParamUser = {
  text: 'Tipo de Acesso'
};

export default formLabelFormParamUser;
